import { createSlice } from '@reduxjs/toolkit';

const blockingErrorSlice = createSlice({
    name: 'blockingError',
    initialState: {
        isOpen: false,
        message: '',
    },
    reducers: {
        showBlockingError: (state, action) => {
            state.isOpen = true;
            state.message = action.payload || '';
        },
        clearBlockingError: (state) => {
            state.isOpen = false;
            state.message = '';
        },
    },
});

export const { showBlockingError, clearBlockingError } = blockingErrorSlice.actions;
export default blockingErrorSlice.reducer;
